import Vue from 'vue';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import { AxiosInstance } from 'axios';
import { Component } from 'vue-property-decorator';
import Vuex from 'vuex';
// import VueEcho from 'vue-echo-laravel';
import store from '@/modules/FPKG-50000-Vuex';
import i18n from '@/modules/FPKG-20000-Util/lang'; // 引入所有語言檔進行整合
import Icon from '@/modules/FPKG-20000-Util/components/b-icon.vue'; // icon 顯示
import status from '@/modules/FPKG-20000-Util/components/b-status-option/index.vue'; // 狀態顯示
import screen from '@/modules/FPKG-20000-Util/prototypes/screen';
import formatNumber from '@/modules/FPKG-20000-Util/prototypes/Format_Number';

import EventBus from './prototypes/bus'; // 公車事件
import router from './vueRouter';
import App from './App.vue';
import axios from './prototypes/axios';

import listStyle from './prototypes/listStyle'; // 站台列表風格
import crud from './prototypes/crud';
import validate from './prototypes/validate';

/** 引入過濾器 */
Vue.filter('$Format_Number', formatNumber);

Vue.mixin(screen);
Vue.mixin(crud);

// import './registerServiceWorker';

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Vuex);

// 必須宣告以下動作才能全域的使用
Vue.prototype.$http = axios;
Vue.prototype.$validate = validate;
Vue.prototype.$listStyle = store.getters.branch;
// 將數字編成千位符號 ex: $Format_Number(55534125,2) ====> 55,534,125.00
Vue.prototype.$Format_Number = formatNumber;

Vue.component('icon', Icon);
Vue.component('status', status);

/** 註冊vueRouter變化鉤子 */
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

declare module 'vue/types/vue' {
  interface Vue {
    $bus: any,
    $echo: any,
    $listStyle: any,
    $http: AxiosInstance,
    $validate(): void;
    $crud: number,
    $getCrud(path: string): number;
    $screen: {
      width: number,
    }
  }
}
new Vue({
  data() {
    return {
      // Bind our event bus to our $root Vue model
      bus: EventBus,
    };
  },
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
